<template>

      <w-menu
        ref="zlmenu"
        hide-on-menu-click
        shadow
        color="indigo-dark3"
        grow
        align-left
        :min-width="mwidth"
        @open="showList"
        @close="closed"
        menu-class="zlookupclass"
        v-model="show"
      >
      <template #activator="{ on }">
        <span v-on="on">
          <z-input
          ref="zlinput"
          v-bind="$attrs"
          :label="label"
          :placeholder="placeholder"
          v-model="keyword"
          autocomplete="off"
          @keyup.stop="keydown"
        />
        </span>
      </template>
      <w-list
        ref="zlist"
        v-model="selection"
        :items="filteredItems"
        :multiple="multiple"
        @item-click="choose"
        class="grow mt0"
      >
      </w-list>
    </w-menu>
</template>

<script>

export default {
  name: 'z-lookup',
  inheritAttrs: false,
  props: {
    label: {
      type: String,
      default: ''
      // default: 'Pilihan'
    },
    placeholder: {
      type: String,
      // default: 'Pilih satu...'
    },
    modelValue: {},
    url: String,
    url_data: [Object, Array],
    options: [Object, Array],
    multiple: {
      type: Boolean,
      default: false,
    },
    sort:  {
      type: Boolean,
      default: true
    },
    cache:  {
      type: Boolean,
      default: true
    },
  },
  emits: ['input', 'update:modelValue'],
  data: () => ({
    selection: 0,
    tmpselection: 0,
    selected: null,
    show: false,
    keyword: '',
    items: [],
    mwidth: 200,
    curitem: -1,
  }),
  mounted() {
    // set the value
    this.selection = this.modelValue
    this.mwidth = this.$refs.zlinput.$el.clientWidth
    // this.items = this.options
    if(this.options) {
      if(this.sort){
        this.items = this.options.sort(this.compare)
        this.setvalue()
      }
      else
        this.items = this.options
        this.setvalue()
    }
    else {
      // check validity
      // console.log('AD' + this.$page.lookup_date)
      var cdate = localStorage.getItem('cache-date');
      if (!cdate || (cdate < (this.$page.props.lookup_date))) {
        localStorage.clear();
        localStorage.setItem('cache-date', Date.now());
      }

      var d, pd
      if((d = localStorage.getItem(this.url)) && this.cache) {
        if(pd = JSON.parse(d)){
          if(this.sort)
            this.options = pd.sort(this.compare)
          else
            this.options = pd
        }
        else {
          this.fetch()
        }
      }
      else if(this.url) {
        this.fetch()
      }
      else {
        this.items = [{ label: 'Please Call Developer', value: 999 }]
      }
    }
  },
  methods: {
    fetch: function () {
      this.$zcomm.lookup(this.url,this.url_data)
        .then(res => {
          if(this.sort)
            this.items = res.sort(this.compare)
          else
            this.items = res
          localStorage.setItem(this.url, JSON.stringify(this.items));
          this.setvalue()
        })
        .catch(err => {
            console.log(err)
        })
    },
    setvalue() {
      const sel = this.items.find(x => x.value == this.selection)
      this.keyword = sel ? sel.label : ''
    },
    setoption: function (opts) {
      this.items = opts
    },
    showList() {
      this.show = true
      this.keyword = ''
      this.tmpselection = this.selection
      this.selection = this.selection ?? 0
      console.log('open: ' + this.selection + ' - ' + this.tmpselection)
    },
    choose(e) {
      this.selected = e
      console.log(this.selected)
      this.keyword = e.label
      this.show = false
      // this.$emit('update:modelValue', e.value)
    },
    closed() {
      this.selection = this.selection > 0 ? this.selection : this.tmpselection
      this.setvalue()
      this.$emit('update:modelValue', this.selection)
      this.show = false
      this.$emit('pilih');
      // console.log('closed: ' + this.selection + ' - ' + this.tmpselection)
    },
    compare(a, b) {
      // Use toUpperCase() to ignore character casing
      const bandA = a.label.toUpperCase();
      const bandB = b.label.toUpperCase();

      let comparison = 0;
      if (bandA > bandB) {
        comparison = 1;
      } else if (bandA < bandB) {
        comparison = -1;
      }
      return comparison;
    },
    keywordFilter: keyword => item => {
      // Concatenate all the columns into a single string for a faster lookup.
      const allTheColumns = `${item.id} ${item.value} ${item.label}`

      // Lookup the keyword variable in the string with case-insensitive flag.
      return new RegExp(keyword, 'i').test(allTheColumns)
    },
    keydown: function(event) {
      switch (event.keyCode) {
        case 13:
        this.selection = this.$refs.zlist.items[this.curitem].value
        this.closed()
        break;
        case 38:
          if(this.show) {
            this.curitem--
          } else {
            this.show = true
          }
          this.curitem = (this.curitem < 0) ? (this.items.length-1) : this.curitem
          // console.log(this.curitem + '-' + this.items.length)
          this.$refs.zlist.applySelectionOnItems(this.$refs.zlist.items[this.curitem].value)
          break;
        case 40:
          if(this.show) {
            this.curitem++
          } else {
            this.show = true
          }
          this.curitem = (this.curitem > (this.items.length-1)) ? 0 : this.curitem
          // console.log(this.curitem + '-' + this.items.length)
          this.$refs.zlist.applySelectionOnItems(this.$refs.zlist.items[this.curitem].value)
          break;
      }
    }
  },
  computed: {
    filteredItems () {
      return this.items.filter(this.keywordFilter(this.keyword))
    },
  },
  watch: {
    modelValue (val) {
      if(!val) {
        this.keyword = ''
      }
    }
  }
}
</script>

<style>
.zlookupclass {
  margin-top: 0px !important;
  z-index: 501;
}
</style>
